jQuery(document).ready(function($) {
    $('.guest-title').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.press-logo').matchHeight({byRow: true, property: 'height', target: null, remove: false});

    $('#slick-featured').slick({
        infinite: true,
        dots: false,
        arrows: false,
        fade: false,
        autoplay: true,
        swipe: true,
        touchMove: true,
        centerMode: false,
        variableWidth: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        rows: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    rows: 1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    rows: 3,
                    slidesToScroll: 1,
                }
            },
        ]
    });
});

